import React, { useState } from "react";
import styles from "./HeroSection.module.css";
import ModalForm from "../ModalForm/ModalForm";

const HeroSection = () => {
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  const heading = "Affordable Flight Booking & Travel Packages Worldwide";
  const description = "Book cheap flights and all-inclusive travel packages to 500+ destinations globally. Compare prices, find exclusive deals, and enjoy 24/7 customer support. Start your adventure today with our trusted flight booking platform offering competitive rates, flexible cancellation, and instant confirmation.";
  const ctaText = "Book Your Flight Now";

  return (
    <div className={styles.heroSection}>
      <div className={styles.heroText}>
        <h1 className={styles.heroTitle}>{heading}</h1>
        <p className={styles.heroDescription}>{description}</p>
        <button className={styles.ctaButton} onClick={openModal}>
          {ctaText}
        </button>
      </div>
      
      <ModalForm isOpen={modalOpen} closeModal={closeModal} />
    </div>
  );
};

export default HeroSection;
